import { useEffect, useState } from "react";
import { userFindAllPG } from "../../api/commonApi";
import { Link } from "react-router-dom";

const BranchesSection = ({ id }) => {
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const response = await userFindAllPG();
        if (response && response.data) {
          setBranches(response.data);
        }
      } catch (error) {
        console.error("Error fetching branches:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBranches();
  }, []);

  return (
    <section id={id} className="container mx-auto px-4 pt-0 pb-16">
      <div className="relative flex items-center justify-center mb-16">
        {/* Gradient Line */}
        <div className="w-full h-[1px] bg-[linear-gradient(to_right,#FBFAF1,#87004C,#FBFAF1)]"></div>

        {/* Center Label */}
        <span className="absolute px-6 py-2 rounded-full bg-[linear-gradient(to_right,#DFC355,#FDF880,#ECDA68)] text-[#87004C] text-sm font-medium shadow">
          Get The App
        </span>
      </div>
      <h2 className="text-center text-4xl font-bold mb-10">
        <span className="text-black heading-style">Our </span>
        <span className="text-[#87004C] heading-style">Branches</span>
      </h2>

      {loading ? (
        <p className="text-center">Loading branches...</p>
      ) : branches.length === 0 ? (
        <p className="text-center">No branches available</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          {branches.map((branch) => (
            <a
              href={branch?.mapUrl}
              target="_blank"
              rel="noopener noreferrer"
              key={branch._id}
              className="bg-white border rounded-2xl shadow-sm overflow-hidden flex flex-col items-center"
            >
              <img
                src={branch.photos && branch.photos[0]}
                alt={branch.name}
                className="w-full h-56 object-cover"
              />
              <div className="p-4 w-full text-center">
                <h3 className="text-lg font-semibold">{branch.name}</h3>
                <div className="flex items-center justify-center mt-1 text-gray-600 text-sm">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-4 h-4 text-pink-600 mr-1"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z" />
                  </svg>
                  {branch.address}
                </div>
              </div>
            </a>
          ))}
        </div>
      )}
    </section>
  );
};

export default BranchesSection;
